
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 58 58"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M50.949 12.187l-.771-.771L40.085 1.322l-.771-.771A1.867 1.867 0 0037.985 0H8.963A2.465 2.465 0 006.5 2.463v53.074A2.465 2.465 0 008.963 58h40.074a2.465 2.465 0 002.463-2.463V13.515c0-.501-.195-.973-.551-1.328zM47.935 12H39.5V3.565L47.935 12zM49.5 55.537a.464.464 0 01-.463.463H8.963a.464.464 0 01-.463-.463V41h41v14.537zM8.5 39V2.463c0-.255.208-.463.463-.463h28.595a1.54 1.54 0 00-.058.392V14h11.608c.135 0 .265-.025.392-.058V39h-41z"}}),_c('path',{attrs:{"d":"M19.5 52c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zM29.5 52c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zM39.5 52c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"}})])])
          )
        }
      }
    